try {
    window.$ = window.jQuery = require('jquery');

} catch (e) { }
// Admin scripts
import Axios from 'axios';
Axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': window.csrf_token
};

require('./admin/index');
require('./uploadFile')
require('./jquery.nestable.js');

require('bootstrap-select-v4');
require('lightgallery.js');
require('bootstrap-colorpicker');
window.autosize = require('autosize');

